<template>
    <div class="DailyLogPane">
        <div>
            <div class="row">
                <div class="col">
                    <div>
                        <h2>Daily Log <font-awesome-icon :icon="['fa', 'sync-alt']" v-on:click="RefreshDataTable()" class="olive-green-text pointer" /></h2>
                        <form class="table-filters client-list">
                            <div class="row">
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <label>House:</label>
                                        <select class="form-control" v-model="Filters.ResidenceID" @change="GetData()">
                                            <option v-for="residence in ResidenceList" :value="residence.Id">
                                                {{ residence.Name }}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <label>Date:</label>
                                        <flat-pickr v-model="Filters.TargetDate" class="form-control" required :config="DateConfig"></flat-pickr>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <label>Search Log:</label>
                                        <input type="text" v-model="search" class="form-control" @input="RedrawTable()" />
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-4">
                                    <button v-if="CheckPermission('ViewActualTimes')" class="btn btn-warning" type="button" @click="ToggleViewingActualTimestamps()">
                                        <font-awesome-icon :icon="['fa', 'eye']" /> VIEW ACTUAL TIMESTAMPS
                                    </button>
                                </div>
                                <div class="col-sm-4">
                                    <h3 class="center-text">{{ ResidenceSelection }}</h3>
                                </div>

                            </div>
                        </form>
                        <vuetable :fields="TableOptions.Fields"
                                  pagination-path=""
                                  :api-mode="false"
                                  class="vue-datatable"
                                  :data-manager="DataManager"
                                  :row-class="onRowClass"
                                  ref="datatable"
                                  >
                            <template slot="Timestamp" scope="props">
                                <div>
                                    {{ formatDateTimeTimestamp(props.rowData.EffectiveDateTime,'hh:mm A') }} <span v-if="ViewingActualTime" :class="{ red: isLateEntry(props.rowData.EffectiveDateTime, props.rowData.CreatedAt)}">({{ formatUTCDateTime(props.rowData.CreatedAt,'MM/DD/YYYY hh:mm A') }})</span>
                                </div>
                            </template>
                            <template slot="Entry" scope="props">
                                <div>
                                    <span class="strikable"> {{ props.rowData.LogMessagePretty }} </span> <span v-if="props.rowData.IsActive == false"> STRIKE OUT BY {{ props.rowData.UpdatedBy }} ON {{ formatUTCDateTime(props.rowData.UpdatedAt, 'MM/DD/YYYY hh:mm A') }}</span>
                                </div>
                            </template>
                            <template slot="Actions" scope="props">
                                <div>
                                    <font-awesome-icon v-if="props.rowData.IsActive && EditMode" :icon="['fa', 'ban']" v-on:click="ShowInactivateModal(props.rowData)" class="red pointer" />
                                </div>
                            </template>
                        </vuetable>
                        <EditMode :EditMode="EditMode" @update-edit-mode="UpdateEditMode"/>
                        <div class="row">
                            <div>
                                <button v-if="Filters.ResidenceID" class="btn btn-success" type="button" @click="ShowNewLogItem" style="position:fixed;bottom:40px;right:40px;z-index:999;">
                                    <font-awesome-icon :icon="['fa', 'plus']" /> ADD ENTRY
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
        </div>

        

        <!--ADD LOG ENTRY-->
        <b-modal ref="add-modal" size="lg" title="Add Log Entry" hide-footer>
            <b-container>
                <b-form @submit="AddEntry" autocomplete="off" class="form-interior">
                    <b-row>
                        <b-col>
                            <h1 class="center-text">{{ ResidenceSelection }}</h1>
                        </b-col>
                        
                    </b-row>
                    <b-row>
                        <b-col>
                            <h3>Entry Info</h3>
                            <b-form-group label="Category:">
                                <b-form-radio v-for="category in LogCategories" v-model="NewLogEntry.Category" name="category-radios" :value="category" required size="lg">{{ category }}</b-form-radio>
                            </b-form-group>
                            <div class="form-group">
                                <label>Event Date:</label>
                                <flat-pickr class="form-control" :config="DateConfig" v-model="NewLogEntry.EffectiveDate" required></flat-pickr>
                            </div>
                            <div class="form-group">
                                <label>Event Time:</label>
                                <flat-pickr class="form-control" :config="TimeConfig" v-model="NewLogEntry.EffectiveTime" required></flat-pickr>
                            </div>
                        </b-col>

                        <b-col>
                            <h3>Log Entry</h3>
                            <div class="form-group">
                                <label>Staff:</label>
                                <div v-for="staff in ResidenceStaff">
                                    <button type="button" class="form-control" @click="StaffNameClick(staff)">{{staff.Name}}</button>
                                </div>
                            </div>
                            <div class="form-group">
                                <label>Clients:</label>
                                <div v-for="client in ResidenceClients">
                                    <button type="button" class="form-control" @click="ClientNameClick(client)">{{client.Name}}</button>
                                </div>
                            </div>
                            <div class="form-group">
                                <label>Description of Event:</label>
                                <textarea ref="logmessage" v-model="NewLogEntry.LogMessageRaw" rows="10" class="form-control" required></textarea>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row class="modal-btn-row">
                        <div class="modal-btn-row-div">
                            <b-button size="md" variant="secondary" @click="CancelEntry()">
                                CANCEL
                            </b-button>
                            <b-button size="md" variant="success" type="submit">
                                SAVE
                            </b-button>
                        </div>
                    </b-row>
                </b-form>
            </b-container>
        </b-modal>

        <!--INACTIVATE MODAL-->
        <b-modal ref="inactivate-modal" size="md" title="Strike Out Entry" hide-footer>
            <b-container>
                <b-form @submit="InactivateEntry" autocomplete="off">
                    <b-row>
                        <b-col>
                            <h3 class="red center-text">WARNING!</h3>
                            <h4 class="red center-text">You are about to strike out this log entry.  This is the equivilant of drawing a line with pen through a paper entry.  This action can not be undone.</h4>
                        </b-col>
                    </b-row>
                    <b-row class="modal-btn-row">
                        <div class="modal-btn-row-div">
                            <b-button size="md" variant="secondary" @click="CancelInactivateModal()">
                                CANCEL
                            </b-button>
                            <b-button size="md" variant="danger" type="submit">
                                STRIKEOUT ENTRY
                            </b-button>
                        </div>
                    </b-row>
                </b-form>
            </b-container>
        </b-modal>
    </div>
</template>

<script>
    //import services
    
    //import components
    //import Vue from 'vue';
    import Vuetable from 'vuetable-2/src/components/Vuetable'
    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';
    import { EventBus } from '../../../services/event-bus.js';
    import EditMode from '../../Core/ItemEditors/EditMode.vue';
    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faSyncAlt } from '@fortawesome/free-solid-svg-icons';
    library.add(faSyncAlt);
    import { faBan } from '@fortawesome/free-solid-svg-icons';
    library.add(faBan);
    import { faPlus } from '@fortawesome/free-solid-svg-icons';
    library.add(faPlus);
    import { faEye } from '@fortawesome/free-solid-svg-icons';
    library.add(faEye);

    export default {
        created() {
            
        },
        props: [],
        data: function () {
            return {
                EditMode: false,
                ViewingActualTime: false,
                TableData: [],
                search: "",
                Filters: {
                    ResidenceID: "",
                    TargetDate: ""
                },
                NewLogEntry: {},
                NewLogEntrySchema: {
                    EffectiveDateTime: "",
                    EffectiveDate: "",
                    EffectiveTime: "",
                    Category: "",
                    LogMessageRaw: "",
                    ResidenceID: "",
                    ClientSubProgramMemberships: []
                },
                ResidenceStaff: [],
                TableOptions: {
                    Fields: [
                        {
                            name: '__slot:Timestamp',
                            title: 'Time',
                            dataClass: 'strikable no-wrap'
                        },
                        {
                            name: 'Category',
                            title: 'Category',
                            dataClass: 'strikable no-wrap'

                        },
                        {
                            name: '__slot:Entry',
                            title: 'Entry'
                        },
                        {
                            name: 'EmployeeAuthor.Person.FirstNameLastInitial',
                            title: 'Author',
                            dataClass: 'strikable no-wrap'
                        },
                        {
                            name: '__slot:Actions',
                            title: '',
                            dataClass: 'strikable'
                        },
                        {
                            name: 'LogMessagePretty',
                            title: '',
                            visible: false
                        }
                    ]
                },
                LogCategories: [
                    "Status Update",
                    "Behavior",
                    "Incident",
                    "Visitor",
                    "Off Site",
                    "On Site",
                    "Informational",
                    "Intensive Watch",
                    "Meal",
                    "Other"
                ],
                DateConfig: {
                    dateFormat: 'Y-m-d',
                    allowInput: true,
                    altInput: true,
                    altFormat: 'm/d/Y',
                    required: false,
                },
                TimeConfig: {
                    enableTime: true,
                    noCalendar: true,
                    dateFormat: 'H:i',
                    allowInput: true,
                    altInput: true,
                    altFormat: 'h:i K'
                }
            };
        },
        methods: {
            ShowInactivateModal(rowData) {
                this.NewLogEntry = rowData;
                this.$refs['inactivate-modal'].show()
            },
            CancelInactivateModal(rowData) {
                this.$refs['inactivate-modal'].hide()
            },
            InactivateEntry(e) {
                e.preventDefault();
                this.$MasterAPI.ExecuteRequest("POST", "Residential/CommunicationLog/InactivateCommunicationLogItem", { Id: this.NewLogEntry.Id }, this.InactivateEntrySuccess, () => { }, true);
            },
            InactivateEntrySuccess(response) {
                this.GetData();
                this.$refs['inactivate-modal'].hide();
            },
            ToggleViewingActualTimestamps() {
                this.ViewingActualTime = !this.ViewingActualTime;
            },
            RefreshDataTable() {
                this.GetData();
                
            },
            ShowNewLogItem() {
                this.NewLogEntry = JSON.parse(JSON.stringify(this.NewLogEntrySchema));
                this.NewLogEntry.ResidenceID = this.Filters.ResidenceID;
                this.NewLogEntry.EffectiveDate = moment().format("YYYY-MM-DD");
                this.NewLogEntry.EffectiveTime = moment().format("HH:mm");
                this.$refs['add-modal'].show();
            },
            CancelEntry() {
                this.$refs['add-modal'].hide();
            },
            AddEntry(e) {
                e.preventDefault();
                this.NewLogEntry.EffectiveDateTime = this.NewLogEntry.EffectiveDate + " " + this.NewLogEntry.EffectiveTime;
                this.$MasterAPI.ExecuteRequest("POST", "Residential/CommunicationLog/AddCommunicationLogItem", this.NewLogEntry, this.AddEntrySuccess, () => { }, true);
            },
            AddEntrySuccess(response) {
                this.GetData();
                this.$refs['add-modal'].hide();
            },
            GetData() {
                if (this.Filters.ResidenceID && this.Filters.TargetDate) {
                    this.$MasterAPI.ExecuteRequest("GET", "Residential/CommunicationLog/GetCommunicationLogItems", this.Filters, this.GetDataSucess, () => { }, true);
                }
                
            },
            GetDataSucess(response) {
                this.TableData = response.data.data;
                this.GetResidenceStaff();
                this.$refs.datatable.refresh();
            },
            formatDateTime (value, fmt = '') {
              return (value == null)
                ? ''
                  : moment(value, 'YYYY-MM-DD HH:mm:ss').format(fmt)
            },
            formatDateTimeTimestamp(value, fmt = '') {
                let currentDate = this.Filters.TargetDate;
                let itemDate = moment(value, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD');
                if (currentDate == itemDate) {
                    return moment(value, 'YYYY-MM-DD HH:mm:ss').format(fmt)
                }
                else {
                    return moment(value, 'YYYY-MM-DD HH:mm:ss').format('hh:mm A (MM/DD/YY)')
                }
            },
            formatUTCDateTime(value, fmt = '') {
                return (value == null)
                    ? ''
                    : moment.utc(value, 'YYYY-MM-DD HH:mm:ss').local().format(fmt)
            },
            isLateEntry(effectiveTime, actualTime) {
                if (Math.abs(moment(effectiveTime, 'YYYY-MM-DD HH:mm:ss').diff(moment.utc(actualTime, 'YYYY-MM-DD HH:mm:ss').local(), 'minutes')) > 30) {
                    return true;
                } else {
                    return false;
                }
            },
            ClientNameClick(client) {
                this.NewLogEntry.LogMessageRaw = this.NewLogEntry.LogMessageRaw + " " + client.Name + " ";
                this.$refs['logmessage'].focus();
            },
            StaffNameClick(staff) {
                this.NewLogEntry.LogMessageRaw = this.NewLogEntry.LogMessageRaw + " " + staff.Name + " ";
                this.$refs['logmessage'].focus();
            },
            onRowClass(dataItem, index) {
                if (!dataItem.IsActive) {
                    return "strikethroughrow";
                } else {
                    return "";
                }
            },
            CheckPermission(permissionName) {
                return this.$store.getters["User.PrivateProfile.CheckPermission"](permissionName);
            },
            RedrawTable() {
                this.$refs.datatable.refresh();
            },
            DataManager(sortOrder, pagination) {
                let dataset = this.filteredList(this.TableData);
                if (dataset.length > 0) {
                    if (sortOrder.length > 0) {
                        if (sortOrder[0].direction == 'asc') {
                            var firstComp = 1;
                            var secondComp = -1;
                        } else {
                            var firstComp = -1;
                            var secondComp = 1
                        }
                        return dataset.sort((a, b) => (this.$FindProperty(a, sortOrder[0].sortField) > this.$FindProperty(b, sortOrder[0].sortField)) ? firstComp : secondComp);
                    } else {
                        return dataset;
                    }
                    
                } else {
                    return [];
                }
            },
            filteredList(inputData) {
                let vm = this;
                let tData = inputData
                if (tData == null) {
                    return [];
                }
                let tFields = vm.$refs["datatable"].tableFields;
                let visibleData = [];
                tData.forEach(function (row, index) {
                    let rowData = [];
                    tFields.forEach(function (field) {
                        rowData.push(vm.$refs.datatable.renderNormalField(field, row));
                        
                    })
                    if (vm.search == "" || JSON.stringify(rowData).toLowerCase().includes(vm.search.toLowerCase())) {
                        visibleData.push(inputData[index]);
                    }
                });
                return visibleData;                  
            },
            UpdateEditMode() {
                this.EditMode = !this.EditMode;
            },
            GetResidenceStaff() {
                this.$MasterAPI.ExecuteRequest("GET", "Residential/CommunicationLog/GetResidenceStaff", { ResidenceId: this.Filters.ResidenceID }, this.GetResidenceStaffSuccess, () => { }, false);
            },
            GetResidenceStaffSuccess(response) {
                this.ResidenceStaff = response.data.data;
            }
        },
        components: {
            Vuetable,
            flatPickr,
            EditMode
        },
        computed: {
            ResidenceList: function () {
                let vm = this;
                let filteredArray = {};
                if (this.CheckPermission("CanViewAllDailyLogsAlways")) {
                    filteredArray = this.UnmodifiedResidenceList;
                }
                else {
                     filteredArray = this.UnmodifiedResidenceList.filter(rl =>
                        rl.EmployeeCheckins = rl.EmployeeCheckins.some(function (ec) {
                            return ec.EmployeeID == vm.UserPrivateProfile.EmployeeID;
                        })
                    );
                }
                return filteredArray;
            },
            ResidenceSelection: function () {
                if (this.ResidenceList.length == 1) {
                    this.Filters.ResidenceID = this.ResidenceList[0].Id;
                }
                let selectedID = this.Filters.ResidenceID;
                if (selectedID && this.$store.state.Residences.ResidenceList.filter(rl => rl.Id == selectedID).length > 0) {
                    return this.$store.state.Residences.ResidenceList.filter(rl => rl.Id == selectedID)[0].Name;
                } else {
                    return "SELECT A HOUSE";
                }
                
            },
            ResidenceClients: function () {
                let vm = this;
                if (this.$store.state.Clients.ClientEnrollmentsList.length > 0) {
                    let clientsInitial = this.$store.state.Clients.ClientEnrollmentsList.filter(c => c.ResidenceName == vm.ResidenceSelection);
                    let output = [];
                    clientsInitial.forEach(function (client) {
                        output.push({
                            Name: client.Person.FirstNameLastInitial,
                            Value: client.Id
                        });
                    });
                    return output;
                } else {
                    return [];
                }
                
            },
            ResidenceStaff: function () {
                let vm = this;
                if (this.$store.state.Clients.ClientEnrollmentsList.length > 0) {
                    let clientsInitial = this.$store.state.Clients.ClientEnrollmentsList.filter(c => c.ResidenceName == vm.ResidenceSelection);
                    let output = [];
                    clientsInitial.forEach(function (client) {
                        output.push({
                            Name: client.Person.FirstNameLastInitial,
                            Value: client.Id
                        });
                    });
                    return output;
                } else {
                    return [];
                }

            },
            UserPrivateProfile: function () {
                return this.$store.state.User.PrivateProfile;
            },
            UnmodifiedResidenceList: function () {
                //create new array reference without modifying the original
                return this.$store.state.Residences.ResidenceList.map(o => ({...o}));
            }
        },
        mounted() {
            this.Filters.TargetDate = moment().format("YYYY-MM-DD");
        },
        watch: {
            //refresh table everytime residence selection changes.
            ResidenceSelection: function (val) {
              this.RefreshDataTable();
            },
        }
    }
</script>

<style scoped>
</style>